import type { ComponentChildren } from 'preact';

/**
 * Standard error tile - soft-red bordered box with a title row, optional body paragraph, and
 * an optional mono "details" line for the underlying technical message.
 */
export function ErrorTile({
  title,
  body,
  details,
  children,
  class: extraClass,
}: {
  title: string;
  body?: ComponentChildren;
  details?: string;
  children?: ComponentChildren;
  class?: string;
}) {
  return (
    <div
      role="alert"
      class={`rounded-md border border-state-failed/40 bg-state-failed/5 p-6 text-state-failed ${extraClass ?? ''}`}
    >
      <div class="font-semibold">{title}</div>
      {body && <div class="mt-2 text-sm">{body}</div>}
      {details && <div class="mt-1 font-mono text-xs opacity-90">{details}</div>}
      {children && <div class="mt-4">{children}</div>}
    </div>
  );
}
